import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GameEngineApiService } from '../../Services/game-engine-api.service';
import { UtilsService } from '../../Services/utils.service';
import { GAME_ACCOUNT_BY_ROUTE } from './game-account/game-account.config';

// Kicks a player out of an instant game (or its account page) the moment staff switch that game to
// Inactive / Under Maintenance in the admin panel. The backend pushes the shared "Offer" socket
// message when the config changes; WebSocketService turns it into UtilsService.triggerOfferHistory(),
// which this service listens to - then asks the server whether the game the player is on is still
// playable and sends them to the home page if not.
@Injectable({ providedIn: 'root' })
export class GameAvailabilityService {
  private router = inject(Router);
  private engine = inject(GameEngineApiService);
  private utils = inject(UtilsService);
  private toastr = inject(ToastrService);
  private started = false;

  start(): void {
    if (this.started) return;
    this.started = true;
    this.utils.getTriggerOfferHistoryObservable().subscribe(() => this.checkCurrentGame());
  }

  // Game the given url belongs to (game route, buy-now for Scratch, or its account page), if any.
  private gameCodeForUrl(url: string): string | null {
    const path = url.split('?')[0].split('#')[0];
    const match = /^\/dashboard\/([^/]+)(?:\/([^/]+))?/.exec(path);
    if (!match) return null;
    const [, first, second] = match;
    if (first.toLowerCase() === 'game-account') return (second || '').toUpperCase() || null;
    if (first.toLowerCase() === 'buy-now') return 'SCRATCH';
    return GAME_ACCOUNT_BY_ROUTE[first.toLowerCase()]?.gameCode ?? null;
  }

  private checkCurrentGame(): void {
    const code = this.gameCodeForUrl(this.router.url);
    if (!code || !localStorage.getItem('token')) return;

    this.engine.getPlayableInfo(code).subscribe({
      next: (r: any) => {
        // GetPlayableInfo returns the info object itself (not wrapped in { data }).
        const info = r?.data ?? r;
        if (!info || (info.isActive === undefined && info.IsActive === undefined)) return;
        const isActive = info.isActive ?? info.IsActive;
        const isMaintenance = info.isUnderMaintenance ?? info.IsUnderMaintenance;
        if (isActive === false || isMaintenance === true) {
          this.toastr.warning('This game is currently unavailable.', 'Game unavailable');
          this.router.navigate(['/dashboard/home']);
        }
      },
      error: () => { /* keep the player where they are; the server still rejects bets */ },
    });
  }
}
